import importReact from "../../utils/importReact";

export default function initTourismEvents() {
  const entrypoint = document.getElementById("tourism-events-container");
  if (entrypoint) {
    import(/* webpackChunkName: "tourismEvents" */ "./TourismEvents").then(
      (e) => {
        const pageSize = parseInt(entrypoint.dataset.pagesize);
        const currentPageRef = parseInt(entrypoint.dataset.currentpage);
        importReact().then(([React, ReactDOM]) => {
          ReactDOM.render(
            React.createElement(e.default, { pageSize, currentPageRef }),
            entrypoint
          );
        });
      }
    );
  }
}
